import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import PinFill from '@icons/pin/PinFill';
import useCalculatedCart from '@store/cart/hooks/useCalculatedCart';
import { useTranslation } from 'react-i18next';

function ShopLocation() {
    const { shopName } = useCalculatedCart();
    const { t } = useTranslation('cart');
    return (
        <Container spacing={1} align='center'>
            <PinFill/>
            <Row>
                <Text size='title' fontWeight='bold'>{shopName}</Text>
                <Text size='title'>
                    {t('shopLocation.orderFrom')}
                </Text>
            </Row>
        </Container>
    );
}

const Container = styled(Row)`
    padding: var(--spacing-6) var(--spacing-4) var(--spacing-3);
`;

export default ShopLocation;
